import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllPackages } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useDeleteAllPackages = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllPkg,
        isPending: isDeleteAll,
    } = useMutation({
        mutationFn: deleteAllPackages,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete packages");
        },
    });

    return {
        deleteAllPkg,
        isDeleteAll,
    };
};

export default useDeleteAllPackages;
